<template>
  <!-- <Modal :hideExit="false" @cancel="closeModal" v-if="modalActive" mClass="" cClass="onboarding-container"> -->
  <Modal :hideExit="false" v-if="isActive" @cancel="closeModal" hClass="p-1" classs="modal-blur pt-2 pb-2" cClass="d-flex align-items-center justify-content-center height-unlimit" closeClass="close-class" mClass="started-guide-container height-unlimit" :noBreakLine="true">
    <template #header>
      <h2 class="typo-heading24 weight-700 text-light-high text-center mb-1">{{ $t('onboarding.select')}}</h2>
      <p class="typo-paragraph14 typo-regular text-light-low text-center">{{$t('onboarding.getFresh')}}</p>
    </template>
    <template #default>
      <template>
        <PerfectScrollbar class="row guide-list justify-content-center justify-content-sm-start">
          <div class="col-12 col-xs-10 col-sm-6 col-md-4 mt-3" v-for="(item,index) in startedGuide" :key="index">
            <div class="item p-2">
              <!-- <a class="thumbnail" target="_blank" :style="{'background-image': 'https://images.unsplash.com/photo-1494253109108-2e30c049369b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80' }" :href="blog.settings.url"> -->
                <!-- <img :src="blog.img_url" alt=""> -->
              <!-- </a> -->
              <div class="thumbnail mb-2">
                <img v-lazyload :data-src="item.img" :src="item.imgLazy" alt="">
              </div>
              <div class="content mb-2">
                <a class="typo-button14 typo-medium mb-1" :ref="'blog'+ index" >{{ item.title }}</a>
                <p class="typo-paragraph12 typo-regular typo-lh150">{{ item.desc }}</p>
              </div>
              <button class="btn btn-block btn-secondary mt-auto" @click="openOnboard(item.action)">{{ $t('onboarding.getStarted')}}</button>
            </div>
          </div>      
        </PerfectScrollbar>
      </template>
    </template>
    <!-- <template #footer>
      <p class="typo-paragraph14 typo-regular-150 text-light-high">
        By choosing Create New Page you can create Sub Pages & Landing Pages from our hand-crafted templates or start from scratch with blank template. When hover on template, you can preview template by click Preview or click Edit to go to editor and start editing.
      </p>
      <div class="btn-group onboarding-btn flex-row-reverse">
        <button class="btn btn-default btn-primary">Next</button>
        <button class="btn btn-default btn-outline mr-1">Previous</button>
      </div>
    </template> -->
  </Modal>
</template>

<script>
import { mapState,mapActions } from "vuex";
import Cookies from "@/utils/cookie.js";
export default {
  name: "StartedGuide",
  data() {
    return {
    };
  },
  computed:{
    startedGuide(){
      return [
        {
          "img":this.publicPath + require("@/core/assets/Dashboardv3/Onboarding/subpages.png"),
          "imgLazy":this.publicPath + require("@/core/assets/Dashboardv3/Onboarding/subpages.jpg"),
          "title":this.$t('onboarding.landingpages.title'),
          "desc":this.$t('onboarding.subpages.desc'),
          "action":"subpages"
        },
        {
          "img":this.publicPath + require("@/core/assets/Dashboardv3/Onboarding/homepages.png"),
          "imgLazy":this.publicPath + require("@/core/assets/Dashboardv3/Onboarding/homepages.jpg"),
          "title":this.$t('onboarding.homepages.title'),
          "desc":this.$t('onboarding.homepages.desc'),
          "action":"homepages"
        },
        {
          "img":this.publicPath + require("@/core/assets/Dashboardv3/Onboarding/productpages.png"),
          "imgLazy":this.publicPath + require("@/core/assets/Dashboardv3/Onboarding/productpages.jpg"),
          "title":this.$t('onboarding.productpages.title'),
          "desc":this.$t('onboarding.productpages.desc'),
          "action":"productpages"
        },
        {
          "img":this.publicPath + require("@/core/assets/Dashboardv3/Onboarding/collectionpages.png"),
          "imgLazy":this.publicPath + require("@/core/assets/Dashboardv3/Onboarding/collectionpages.jpg"),
          "title":this.$t('onboarding.collectionpages.title'),
          "desc":this.$t('onboarding.collectionpages.desc'),
          "action":"collectionpages"
        },
        {
          "img":this.publicPath + require("@/core/assets/Dashboardv3/Onboarding/blogpost.png"),
          "imgLazy":this.publicPath + require("@/core/assets/Dashboardv3/Onboarding/blogpost.jpg"),
          "title":this.$t('onboarding.articlepages.title'),
          "desc":this.$t('onboarding.articlepages.desc'),
          "action":"articlepages"
        },
        {
          "img":this.publicPath + require("@/core/assets/Dashboardv3/Onboarding/integration.png"),
          "imgLazy":this.publicPath + require("@/core/assets/Dashboardv3/Onboarding/integration.jpg"),
          "title":this.$t('onboarding.integrations.title'),
          "desc":this.$t('onboarding.integrations.desc'),
          "action":"integrations"
        }
      ]
    },
    ...mapState("tutorial", {
      isActive: state => state.onboarding.isModalActive
    }), 
  },
  methods: {
    ...mapActions("tutorial", {
      closeStarted: "closeStartedGuide",
    }),
    openOnboard(action){
      this.$emit('open_onboard',action);
      Cookies.set("gfStartedGuide", "seen", 3 * 365 * 24 * 3600);
      this.closeStarted()
    },
    closeModal(){
      Cookies.set("gfStartedGuide", "seen", 3 * 365 * 24 * 3600);
      this.closeStarted()
    }
  }
};
</script>

<style lang="scss" scoped>
// .started-guide-container {
  .guide-list{
    max-height: calc(100vh - 102px);
    .item{
      border-radius: $radius;
      background: $light1;
      display: flex;
      flex-direction: column;
      height: 100%;
      .thumbnail{
        max-width: 100%;
        >img{
          min-height: 137px;
          width:100%
        }
      }
      .btn{
        height: 40px;
      }
    }
  }
// }
</style>
